<section class="section testimonials-details">
  <div class="container-xl">
    <div class="section-title">
      <h1 class="title" ngClass.lt-md="text-center">{{ livreBlanc?.titre }}</h1>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start start" fxLayoutGap="30px">
    <div class="section-left" fxFlex="50">
      <img [src]="livreBlanc?.image?.url" [alt]="livreBlanc?.image?.alternativeText" class="w-100" />
      <div class="content" [innerHTML]="livreBlanc?.content | markdown"></div>
    </div>
    <div class="section-right" fxFlex="50">
      <h3 class="subtitle" [innerHTML]="livreBlanc?.sous_texte | markdown"></h3>
      <div class="form">
        <b2b-ui-download-form
          [formControl]="form"
          [agree]="{ agreeText: livreBlanc?.agreeText, agreeDescription: livreBlanc?.agreeDescription }"
        ></b2b-ui-download-form>
      </div>
    </div>
  </div>
</section>

<!-- Discover -->
<b2b-ui-section-discover
  [text]="ctaSeo?.CTA4"
  [linkText]="ctaSeo?.intitule_CTA4"
  [linkUrl]="ctaSeo?.cible_CTA4"
></b2b-ui-section-discover>

<!-- Garanties -->
<b2b-ui-section-garantee></b2b-ui-section-garantee>
